'use strict';

angular.module('shiftTraderApp')
  .service('DaysOffRouteSyncService', ['$log', '$rootScope', function ($log, $rootScope) {
      var selectedFilters = {};

    function broadcastFilterChange() {
      $rootScope.$broadcast('daysOff:filterChange');
    }

      this.setFilters = function(filters) {
        selectedFilters = filters;
        broadcastFilterChange();

        return true;
      };

      this.getFilters = function() {
        return selectedFilters;
      };
    }]);
